import { render } from "./PokemonOptions.vue?vue&type=template&id=10d97ed8&scoped=true"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=10d97ed8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10d97ed8"

export default script